import { useState, useEffect } from 'react';

export const useMenuEvents = (open, onClose, isEditing, inputRef, menuRootRef) => {
  const [hoverIdx, setHoverIdx] = useState(-1);

  // 외부 클릭 시 닫기
  useEffect(() => {
    if (!open) return;
    
    const handleClickOutside = (e) => {
      if (isEditing && inputRef.current && inputRef.current.contains(e.target)) {
        return;
      }
      if (
        menuRootRef.current &&
        !menuRootRef.current.contains(e.target)
      ) {
        onClose && onClose();
      }
    };
    
    // mousedown과 click 둘 다 감지하여 더 확실하게 처리
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [open, onClose, isEditing, inputRef, menuRootRef]);

  return { hoverIdx, setHoverIdx };
}; 